<div class="routing-back-wrapper">
  <a [routerLink]="routerLink" class="routing-back-label">{{
    routingBackLabel
  }}</a>
</div>
